import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, NgModule, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowdownService } from '../helpers/showdown/showdown.service';


export class ShowdownComponent implements AfterViewInit, OnChanges {
	 public text: string;
	 public showdownContainer: ElementRef;

	private showdownService = new ShowdownService();

	public ngAfterViewInit() {
		this.setMarkdownCode();
	}

	public ngOnChanges(changes: SimpleChanges) {
		this.setMarkdownCode();
	}

	private setMarkdownCode() {
		if (!this.showdownContainer) {
			return;
		}
		this.showdownContainer.nativeElement.innerHTML = this.showdownService.convertToHtml(this.text);
	}
}


export class ShowdownModule {
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/components/showdown.module.ts